import React from 'react';
import FollowUpAgenciamentoRegistrationPageBase from './FollowUpAgenciamentoRegistrationPageBase';

export default function FollowUpAgenciamentoRegistrationExportMaritimoPage(props) {
  return (
    <FollowUpAgenciamentoRegistrationPageBase
      {...props}
      urlPosSalvar={(created) => `/exportacao/agenciamento/maritimo/follow-up?processo=${created?.numero || ''}`}
      breadcrumbConfig={(t, actionName) => [
        {
          link: { to: '/', name: t('com.muralis.qcx.inicio') },
        },
        {
          link: { to: '/exportacao/agenciamento/maritimo', name: 'Exportação Agenciamento Marítimo' },
        },
        {
          link: { to: '/exportacao/agenciamento/maritimo/follow-up', name: 'Follow-Up' },
        },
        { text: { name: t('com.muralis.qcx.registro') } },
        { text: { name: actionName } },
      ]}
    />
  );
}
